// extracted by mini-css-extract-plugin
module.exports = {"user-info-confirmation":"user-info-confirmation__13LEd","confirmation-item":"confirmation-item__3q3sV","label":"label__Bvjmc","value":"value__38g_x"};